export default {
  host: 'https://discovery-ams.sotalcloud.com/sdp/v2',
  endpoints: {
    ads: '/ads',
    authorize: '/authorize',
    bootstrap: '/bootstrap',
    assets: '/assets',
    dvrTasks: '/dvr-tasks',
    auth: '/authorize',
    profile: '/subscribers/me',
    pc: '/devices/me',
    subs: '/subscriptions',
    liveEvents: '/live-events',
    screens: '/screens',
  },
} as const;
